import { createSlice } from '../wrappers';

import { photoModeFilters } from '~/shared';
import {
	HorizontalLogoPositions,
	VerticalLogoPositions,
} from '../../components/Logo';

interface IPhotoModeSlice {
	interfaceHidden: boolean;
	filterActive: {
		id: string;
		name: string;
	};
	grid: boolean;
	format: 'horizontal' | 'vertical';
	horizontalLogoPosition: HorizontalLogoPositions;
	verticalLogoPosition: VerticalLogoPositions;
}

const initialState: IPhotoModeSlice = {
	interfaceHidden: false,
	filterActive: photoModeFilters[0],
	grid: false,
	format: 'horizontal',
	horizontalLogoPosition: HorizontalLogoPositions.UP_LEFT,
	verticalLogoPosition: VerticalLogoPositions.UP,
};

const photoModeSlice = createSlice({
	name: 'photoMode',
	initialState,
	reducers: {
		toggleInterfaceHidden: (state) => {
			state.interfaceHidden = !state.interfaceHidden;
		},
		toggleGrid: (state) => {
			state.grid = !state.grid;
		},
		toggleFormat: (state) => {
			if (state.format === 'horizontal') {
				state.format = 'vertical';
				return;
			}

			state.format = 'horizontal';
		},
		toggleHorizontalLogoPosition: (state) => {
			const positions = Object.values(HorizontalLogoPositions);

			let index = positions.indexOf(state.horizontalLogoPosition);
			if (index === positions.length - 1) {
				index = 0;
			} else {
				index = index + 1;
			}

			state.horizontalLogoPosition = positions[index];
		},
		toggleVerticalLogoPosition: (state) => {
			const positions = Object.values(VerticalLogoPositions);

			let index = positions.indexOf(state.verticalLogoPosition);
			if (index === positions.length - 1) {
				index = 0;
			} else {
				index = index + 1;
			}

			state.verticalLogoPosition = positions[index];
		},
		toggleFilter: (state) => {
			let index = photoModeFilters.findIndex(
				(e) => e.id === state.filterActive.id,
			);
			index = (index + 1) % photoModeFilters.length;
			state.filterActive = photoModeFilters[index];
		},
		resetSettings: (state) => {
			state.filterActive = initialState.filterActive;
			state.interfaceHidden = initialState.interfaceHidden;
			state.grid = initialState.grid;
			state.format = initialState.format;
			state.verticalLogoPosition = initialState.verticalLogoPosition;
			state.horizontalLogoPosition = initialState.horizontalLogoPosition;
		},
	},
});

export const {
	toggleInterfaceHidden,
	toggleGrid,
	toggleFormat,
	toggleHorizontalLogoPosition,
	toggleVerticalLogoPosition,
	toggleFilter,
	resetSettings,
} = photoModeSlice.actions;

export default photoModeSlice.reducer;
